<template>
    <!--
      BLOCO P — item 2 do módulo PROFESSORES, lacuna encontrada na AUDITORIA FINAL DA FASE 2.

      "Permitir aos gestores configurar o processo de aprovação dos planejamentos de aulas,
      definindo os estabelecimentos de ensino, as modalidades e os professores que devem
      seguir este processo, bem como definir o período que o processo deve acontecer e o
      prazo máximo que o professor pode registrar o planejamento."

      O backend estava completo desde o Bloco P (8 rotas + PlanejamentoConfiguracaoService),
      mas NENHUMA tela o consumia — o gestor não tinha como configurar nada. Esta tela é o
      consumidor que faltava.

      A precedência entre escopos é decidida no backend (`getEfetiva`): professor vence
      escola, que vence rede. A tela apenas exibe essa ordem; não a reimplementa.
    -->
    <div class="main">
        <el-form label-position="top">
            <el-row :gutter="10">
                <el-col :xs="24" :sm="6">
                    <el-form-item label="Período letivo">
                        <el-select v-model="filtro.periodo_letivo_id" @change="carregar()" style="width: 100%;">
                            <el-option v-for="(item, i) in $store.state.periodos" :key="i"
                                       :label="'Periodo Letivo ' + item.nome" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="6">
                    <el-form-item label="Abrangência">
                        <el-select v-model="filtro.escopo" clearable placeholder="Todas"
                                   @change="carregar()" style="width: 100%;">
                            <el-option v-for="(rotulo, chave) in escopos" :key="chave"
                                       :label="rotulo" :value="chave"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="6">
                    <el-form-item label="Nome">
                        <el-input v-model="filtro.nome" clearable placeholder="Buscar"
                                  @keyup.enter.native="carregar()"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="6" class="u-text-right">
                    <el-button class="u-mt-30" @click="carregar()">BUSCAR</el-button>
                    <el-button class="u-mt-30 u-ml-10" type="primary" @click="abrirNovo()">
                        <i class="el-icon-plus"></i> NOVA
                    </el-button>
                </el-col>
            </el-row>
        </el-form>

        <el-alert v-if="erro" :title="erro" type="error" :closable="false" class="u-mb-15"></el-alert>

        <el-alert v-if="padrao" type="info" :closable="false" class="u-mb-15"
                  :title="textoPadrao"></el-alert>

        <div v-if="carregando" class="u-text-center u-mt-20">Carregando...</div>

        <el-table v-else :data="itens" border size="mini"
                  empty-text="Nenhuma configuração cadastrada. Sem configuração, vale o padrão indicado acima.">
            <el-table-column prop="nome" label="Configuração" min-width="180"></el-table-column>

            <el-table-column label="Abrangência" width="150">
                <template slot-scope="s">
                    <el-tag size="mini">{{ escopos[s.row.escopo] || s.row.escopo }}</el-tag>
                </template>
            </el-table-column>

            <el-table-column label="Aplica-se a" min-width="170">
                <template slot-scope="s">
                    <span v-if="s.row.escopo === 'rede'">Toda a rede municipal</span>
                    <span v-else-if="s.row.escopo === 'instituicao'">{{ nomeInstituicao(s.row.escopo_id) }}</span>
                    <span v-else>{{ nomeServidor(s.row) }}</span>
                </template>
            </el-table-column>

            <el-table-column label="Modalidade" width="140">
                <template slot-scope="s">
                    <span v-if="!s.row.modalidade_id" class="vazio">Todas</span>
                    <span v-else>{{ nomeModalidade(s.row.modalidade_id) }}</span>
                </template>
            </el-table-column>

            <el-table-column label="Periodicidade" width="120">
                <template slot-scope="s">{{ rotuloPeriodicidade(s.row.periodicidade) }}</template>
            </el-table-column>

            <el-table-column label="Prazo" width="110">
                <template slot-scope="s">
                    <span v-if="s.row.prazo_dias === null" class="vazio">Sem prazo</span>
                    <span v-else>{{ s.row.prazo_dias }} dia(s)</span>
                </template>
            </el-table-column>

            <el-table-column label="Exige aprovação" width="130">
                <template slot-scope="s">{{ s.row.exige_aprovacao ? 'Sim' : 'Não' }}</template>
            </el-table-column>

            <el-table-column label="Bloqueia após prazo" width="150">
                <template slot-scope="s">{{ s.row.bloqueia_apos_prazo ? 'Sim' : 'Não' }}</template>
            </el-table-column>

            <el-table-column label="Situação" width="90">
                <template slot-scope="s">
                    <el-tag size="mini" :type="s.row.situacao ? 'success' : 'info'">
                        {{ s.row.situacao ? 'Ativa' : 'Inativa' }}
                    </el-tag>
                </template>
            </el-table-column>

            <el-table-column label="" width="200">
                <template slot-scope="s">
                    <el-button size="mini" @click="abrirEdicao(s.row)">EDITAR</el-button>
                    <el-button class="u-ml-10" size="mini" type="danger" @click="excluir(s.row)">EXCLUIR</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="u-mt-10 u-text-right" v-if="paginacao.last_page > 1">
            <el-pagination background layout="prev, pager, next"
                           :current-page="paginacao.current_page" :page-size="paginacao.per_page"
                           :total="paginacao.total" @current-change="irPara"></el-pagination>
        </div>

        <p v-if="precedencia.length" class="precedencia">
            Quando mais de uma configuração alcança a mesma turma, vale a mais específica:
            <b>{{ precedencia.map(p => escopos[p] || p).join(' → ') }}</b>.
        </p>

        <!-- Formulário -->
        <el-dialog :title="form.id ? 'Editar configuração' : 'Nova configuração'"
                   :visible.sync="dialog" width="560px">
            <el-form label-position="top" class="u-mt-20">

                <el-row :gutter="10">
                    <el-form-item label="Nome da configuração">
                        <el-input v-model="form.nome" maxlength="191"
                                placeholder="Ex.: Aprovação obrigatória — Ensino Fundamental"></el-input>
                    </el-form-item>
                </el-row>

                <el-row :gutter="10">
                    <el-col :span="12">
                        <el-form-item label="Abrangência">
                            <el-select v-model="form.escopo" @change="form.escopo_id = ''" style="width: 100%;">
                                <el-option v-for="(rotulo, chave) in escopos" :key="chave"
                                           :label="rotulo" :value="chave"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="Período letivo">
                            <el-select v-model="form.periodo_letivo_id" style="width: 100%;">
                                <el-option v-for="(item, i) in $store.state.periodos" :key="i"
                                           :label="'Periodo Letivo ' + item.nome" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <!-- Estabelecimento de ensino (item 2) -->
                    <el-form-item v-if="form.escopo === 'instituicao'" label="Estabelecimento de ensino">
                        <el-select v-model="form.escopo_id" filterable placeholder="Selecione a escola"
                                style="width: 100%;">
                            <el-option v-for="(item, i) in $store.state.instituicoes" :key="i"
                                    :label="item.nome" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-row>

                <el-row :gutter="10">
                    <!-- Professor (item 2) -->
                    <el-form-item v-if="form.escopo === 'servidor'" label="Professor">
                        <el-select v-model="form.escopo_id" filterable remote clearable
                                :remote-method="buscarProfessores" :loading="buscandoProfessor"
                                placeholder="Digite o nome do professor" style="width: 100%;">
                            <el-option v-for="p in professores" :key="p.id" :label="p.nome" :value="p.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-row>

                <el-row :gutter="10">
                    <!-- Modalidade (item 2) -->
                    <el-form-item label="Modalidade (opcional)">
                        <el-select v-model="form.modalidade_id" clearable placeholder="Todas as modalidades"
                                filterable style="width: 100%;">
                            <el-option v-for="m in modalidades" :key="m.id" :label="m.nome" :value="m.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-row>

                <el-row :gutter="10">
                    <el-col :span="12">
                        <el-form-item label="Periodicidade do planejamento">
                            <el-select v-model="form.periodicidade" style="width: 100%;">
                                <el-option v-for="p in periodicidades" :key="p"
                                           :label="rotuloPeriodicidade(p)" :value="p"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <!-- prazo máximo para o professor registrar (item 2) -->
                        <el-form-item label="Prazo máximo para registrar (dias)">
                            <el-input v-model="form.prazo_dias" type="number" min="0"
                                      placeholder="Em branco = sem prazo"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-checkbox v-model="form.exige_aprovacao">
                    Os planejamentos precisam ser aprovados pelo gestor
                </el-checkbox>
                <br>
                <el-checkbox v-model="form.bloqueia_apos_prazo">
                    Bloquear o registro depois de vencido o prazo
                </el-checkbox>
                <br>
                <el-checkbox v-model="form.situacao">Configuração ativa</el-checkbox>

                <el-alert v-if="erroForm" :title="erroForm" type="error" :closable="false" class="u-mt-10"></el-alert>
            </el-form>

            <span slot="footer">
                <el-button @click="dialog = false">CANCELAR</el-button>
                <el-button class="u-ml-10" type="primary" :loading="salvando" @click="salvar()">SALVAR</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
const ROTULO_PERIODICIDADE = {
    diaria: 'Diária', semanal: 'Semanal', quinzenal: 'Quinzenal',
    mensal: 'Mensal', bimestral: 'Bimestral'
}

export default {
    data: () => ({
        itens: [],
        escopos: {},
        periodicidades: [],
        precedencia: [],
        padrao: null,
        modalidades: [],
        professores: [],
        filtro: { periodo_letivo_id: '', escopo: '', nome: '', page: 1 },
        paginacao: { current_page: 1, per_page: 30, total: 0, last_page: 1 },
        form: {},
        dialog: false,
        carregando: false,
        salvando: false,
        buscandoProfessor: false,
        erro: '',
        erroForm: ''
    }),
    computed: {
        textoPadrao () {
            if (!this.padrao) return ''

            const exige = this.padrao.exige_aprovacao ? 'exigem aprovação' : 'não exigem aprovação'
            const prazo = this.padrao.prazo_dias === null || this.padrao.prazo_dias === undefined
                ? 'sem prazo' : `prazo de ${this.padrao.prazo_dias} dia(s)`

            return `Turmas sem configuração seguem o padrão do sistema: periodicidade `
                 + `${this.rotuloPeriodicidade(this.padrao.periodicidade)}, ${exige}, ${prazo}.`
        }
    },
    mounted () {
        this.filtro.periodo_letivo_id = this.$store.state.config.parametros.periodo_letivo_situacao_academica

        this.initForm()
        this.getModalidades()
        this.carregar()
    },
    methods: {
        /** Escopos, periodicidades e precedência vêm do backend — a tela não os inventa. */
        initForm () {
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/planejamento-configuracao/initForm`,
                            this.$store.getters.getHeaderAuth).then(r => {
                const d = r.data || {}
                if (d.erro || d.error) { this.erro = d.erro || d.error; return }

                this.escopos = d.escopos || {}
                this.periodicidades = d.periodicidades || []
                this.precedencia = d.precedencia || []
                this.padrao = d.padrao_sem_configuracao || null
            }).catch(e => this.tratarFalha(e, 'erro'))
        },

        getModalidades () {
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/modalidade/getAll`,
                            this.$store.getters.getHeaderAuth).then(r => {
                const d = r.data || {}
                if (d.erro || d.error) return
                this.modalidades = Array.isArray(d) ? d : (d.data || [])
            }).catch(() => { this.modalidades = [] })
        },

        carregar () {
            this.erro = ''
            this.carregando = true

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/planejamento-configuracao/getAllPaginate`,
                             this.filtro, this.$store.getters.getHeaderAuth).then(r => {
                this.carregando = false
                const d = r.data || {}

                if (d.erro || d.error) { this.erro = d.erro || d.error; return }

                this.itens = d.data || []
                this.paginacao = {
                    current_page: d.current_page || 1, per_page: d.per_page || 30,
                    total: d.total || 0, last_page: d.last_page || 1
                }
            }).catch(e => { this.carregando = false; this.tratarFalha(e, 'erro') })
        },

        irPara (p) { this.filtro.page = p; this.carregar() },

        abrirNovo () {
            this.erroForm = ''
            this.professores = []
            this.form = {
                nome: '', escopo: 'instituicao', escopo_id: '',
                periodo_letivo_id: this.filtro.periodo_letivo_id,
                modalidade_id: '', periodicidade: 'semanal', prazo_dias: '',
                exige_aprovacao: true, bloqueia_apos_prazo: false, situacao: true
            }
            this.dialog = true
        },

        abrirEdicao (linha) {
            this.erroForm = ''
            this.professores = []
            this.form = Object.assign({}, linha)

            if (linha.escopo === 'servidor' && linha.escopo_id) {
                this.professores = [{ id: linha.escopo_id, nome: this.nomeServidor(linha) }]
            }

            this.dialog = true
        },

        buscarProfessores (termo) {
            if (!termo || termo.length < 3) { this.professores = []; return }

            this.buscandoProfessor = true

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/servidor/searchByNome`,
                             { query: termo }, this.$store.getters.getHeaderAuth).then(r => {
                this.buscandoProfessor = false
                const d = r.data || {}
                if (d.erro || d.error) { this.professores = []; return }
                this.professores = Array.isArray(d) ? d : (d.data || [])
            }).catch(() => { this.buscandoProfessor = false; this.professores = [] })
        },

        salvar () {
            this.erroForm = ''
            this.salvando = true

            const payload = Object.assign({}, this.form)

            // Em branco significa "sem prazo", não zero.
            payload.prazo_dias = (payload.prazo_dias === '' || payload.prazo_dias === null)
                ? null : Number(payload.prazo_dias)

            if (payload.escopo === 'rede') payload.escopo_id = null

            const url = payload.id
                ? `${this.$store.state.config.baseUrlApi}/api/planejamento-configuracao/update/${payload.id}`
                : `${this.$store.state.config.baseUrlApi}/api/planejamento-configuracao/store`

            this.$axios.post(url, payload, this.$store.getters.getHeaderAuth).then(r => {
                this.salvando = false
                const d = r.data || {}

                // O Service recusa escopo alheio, prazo inválido e escopo sem alvo.
                if (d.erro || d.error) { this.erroForm = d.erro || d.error; return }

                this.dialog = false
                this.$message.success('Configuração salva.')
                this.carregar()
            }).catch(e => { this.salvando = false; this.tratarFalha(e, 'erroForm') })
        },

        excluir (linha) {
            this.$confirm(`Excluir a configuração "${linha.nome}"?`, 'Confirmação', { type: 'warning' })
                .then(() => {
                    this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/planejamento-configuracao/delete/${linha.id}`,
                                       this.$store.getters.getHeaderAuth).then(r => {
                        const d = r.data || {}
                        if (d.erro || d.error) { this.$message.error(d.erro || d.error); return }
                        this.$message.success('Configuração excluída.')
                        this.carregar()
                    }).catch(e => this.tratarFalha(e))
                }).catch(() => {})
        },

        /**
         * `state.instituicoes` é um OBJETO indexado por id, não um array — é o formato que
         * o `initSistema` devolve. Chamar `.find()` nele lançava TypeError no meio do
         * render da tabela, e o Vue abortava a linha inteira: a configuração recém-criada
         * existia no banco, mas a listagem não desenhava nada.
         *
         * A busca é pela chave (O(1)); o `Object.values` fica como rede caso o backend
         * passe a devolver um array.
         */
        nomeInstituicao (id) {
            const mapa = this.$store.state.instituicoes || {}
            const i = mapa[id] || Object.values(mapa).find(x => x && String(x.id) === String(id))
            return i ? i.nome : `Instituição ${id}`
        },

        nomeModalidade (id) {
            const m = this.modalidades.find(x => x.id === id)
            return m ? m.nome : `Modalidade ${id}`
        },

        nomeServidor (linha) {
            if (linha.servidor && linha.servidor.nome) return linha.servidor.nome
            return linha.escopo_id ? `Professor ${linha.escopo_id}` : '—'
        },

        rotuloPeriodicidade (p) { return ROTULO_PERIODICIDADE[p] || p || '—' },

        tratarFalha (e, campo) {
            const d = (e && e.response && e.response.data) ? e.response.data : {}
            const msg = d.erro || d.error || 'Não foi possível concluir a operação.'
            if (campo) this[campo] = msg
            else this.$message.error(msg)
        }
    }
}
</script>

<style scoped>
.vazio { color: #c0c4cc; }
.precedencia { font-size: 12px; color: #909399; margin-top: 12px; }
</style>
